import { Modal, Link } from "@shopify/polaris";
import React, { useState, useCallback } from "react";
import FlippingBook from "./FlippingBook";

function FlippingBookModal(props) {
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);
  const activator = (
    <Link onClick={handleChange}>{props.linkTitle}</Link>
  );

  return (
    <Modal
      activator={activator}
      open={active}
      onClose={handleChange}
      large={false}
      title={props.data.title}
      className="course-book-modal"

    >
      <Modal.Section>
        <FlippingBook data={props.data} />
      </Modal.Section>
    </Modal>
  );
}

export default FlippingBookModal;
